import { render, staticRenderFns } from "./settlement.vue?vue&type=template&id=7b41d968&scoped=true&"
import script from "./settlement.vue?vue&type=script&lang=js&"
export * from "./settlement.vue?vue&type=script&lang=js&"
import style0 from "./settlement.vue?vue&type=style&index=0&id=7b41d968&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b41d968",
  null
  
)

export default component.exports